import type {
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  ListApiKeysResponse,
  RevokeApiKeyResponse,
  UpdateApiKeyRequest,
  UpdateApiKeyResponse,
} from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

/**
 * Typed wrappers around platform-api `/v1/keys/*`.
 *
 * Every function accepts a `fetchImpl` so tests can inject a fake.
 * Production callers get `window.fetch` via the session-provider
 * context.
 */

const BASE_PATH = '/v1/keys';

export async function listApiKeys(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListApiKeysResponse> {
  return platformApiRequest<ListApiKeysResponse>(BASE_PATH, { signal }, fetchImpl);
}

export async function createApiKey(
  body: CreateApiKeyRequest,
  fetchImpl: typeof fetch,
): Promise<CreateApiKeyResponse> {
  return platformApiRequest<CreateApiKeyResponse>(
    BASE_PATH,
    { method: 'POST', body },
    fetchImpl,
  );
}

export async function updateApiKey(
  id: string,
  body: UpdateApiKeyRequest,
  fetchImpl: typeof fetch,
): Promise<UpdateApiKeyResponse> {
  return platformApiRequest<UpdateApiKeyResponse>(
    `${BASE_PATH}/${encodeURIComponent(id)}`,
    { method: 'PATCH', body },
    fetchImpl,
  );
}

export async function revokeApiKey(
  id: string,
  fetchImpl: typeof fetch,
): Promise<RevokeApiKeyResponse> {
  return platformApiRequest<RevokeApiKeyResponse>(
    `${BASE_PATH}/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
